import { configureStore } from '@reduxjs/toolkit';
import './reducers'
import kingGame from "./reducers";
export default configureStore({
    reducer: {
        kingGame : kingGame,
    },
});
